import 'angular';
import { propertyOffersComponent } from './property-offers.component';
import Search from './../search/search.module';
import WebWalk from './../webwalk-util/webwalk.module';
import favouriteService from './../favourites/service/favourites-service.module';

const MODULE_NAME = 'propertyOffers';

export default angular.module(MODULE_NAME, [Search, WebWalk, favouriteService]).component('propertyOffers', propertyOffersComponent).name;


